/**
 * window.MediaCulling
 *
 * Drops the decoded bitmap of a product photo that is off-screen but still has
 * to hold its box. Only the <img> source is swapped — the element keeps its
 * layout size from the container's aspect-ratio — so culling never moves
 * anything. Without it, iOS Safari discards the whole tab on a product with
 * many full-size photos.
 *
 * Shared by <product-gallery> (the media track) and <product-modal> (the zoom
 * view). They cull different subtrees but stash into the same data-cull-*
 * attributes, so this file is the single definition of that contract.
 */
if (!window.MediaCulling) {
  const BLANK_PIXEL = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

  // A root may be an <img> itself or an element wrapping several.
  const imagesIn = (root) => (root.tagName === 'IMG' ? [root] : Array.from(root.querySelectorAll('img')));

  window.MediaCulling = {
    cull(img) {
      if (img.dataset.cullSrc != null) return;

      img.dataset.cullSrc = img.getAttribute('src') || '';
      img.dataset.cullSrcset = img.getAttribute('srcset') || '';
      img.removeAttribute('srcset');
      img.src = BLANK_PIXEL;
    },

    restore(img) {
      if (img.dataset.cullSrc != null) {
        img.src = img.dataset.cullSrc;
        delete img.dataset.cullSrc;
      }
      if (img.dataset.cullSrcset != null) {
        img.srcset = img.dataset.cullSrcset;
        delete img.dataset.cullSrcset;
      }
    },

    cullWithin(root) {
      if (root) imagesIn(root).forEach((img) => this.cull(img));
    },

    restoreWithin(root) {
      if (root) imagesIn(root).forEach((img) => this.restore(img));
    },
  };
}
